import React from 'react';
import '../Styles/HotItemCard.css';


const HotAccessoriesCard = ({image,price,name}) => {
    return (
      <div className='HotItemCard'>
          <img src={image} alt="music products"/>
          <p>{name}</p>
          <span>{price}</span>
      </div>
    )
  }

export default HotAccessoriesCard
